import type { UserEventCategory } from "@/services/api/cronos/user/events/get-all"

const categoriesInfo: Record<UserEventCategory, { icon: string; label: string; color: string }> = {
  recreation: {
    icon: "🏕️",
    label: "Ocio/Recreación",
    color: "#F97316",
  },
  study: {
    icon: "🏫️",
    label: "Cursada",
    color: "#DC2626",
  },
  study_time: {
    icon: "📚️",
    label: "Tiempo de estudio",
    color: "#16A34A",
  },
  wellness: {
    icon: "🧘️",
    label: "Salud y Bienestar",
    color: "#14B8A6",
  },
  work: {
    icon: "💼️",
    label: "Trabajo",
    color: "#0284C7",
  },
}

export default function getEventCategoryInfo(eventCategory: UserEventCategory) {
  return categoriesInfo[eventCategory]
}
